import { useInfiniteQuery } from '@tanstack/react-query';
import { queryKey } from '../../../../../constant/queryKey';
import { mumulLiveService } from 'shared/src/api';
import { useIsMumulLiveExpTarget } from '../hooks/useIsMumulLiveExpTarget';

/**
 * 무물라이브 프로필 콘텐츠 목록 조회 (최신순, next_token 기반 페이징).
 * 실험 대상(EXP1867 A/B군)이고 `profileSno`(market.mumul_live_profile_sno)가
 * 있을 때만 호출한다. 대조군(A)은 UI 노출 없이 CHECK_EXP_1867_TARGET 로깅용으로만 쓴다.
 */
export const useMumulLiveProfilePosts = (profileSno: number | null) => {
  const isExpTarget = useIsMumulLiveExpTarget();

  return useInfiniteQuery({
    queryKey: queryKey.mumulLiveProfilePosts(profileSno ?? 0),
    queryFn: ({ pageParam }) =>
      mumulLiveService.getMumulLiveProfilePosts(
        profileSno as number,
        pageParam,
      ),
    initialPageParam: null as string | null,
    getNextPageParam: lastPage => lastPage.next_token,
    enabled: isExpTarget && profileSno != null,
  });
};
